import { render, staticRenderFns } from "./CrearCliente.vue?vue&type=template&id=e45207b4&"
import script from "./CrearCliente.vue?vue&type=script&lang=ts&"
export * from "./CrearCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e45207b4', component.options)
    } else {
      api.reload('e45207b4', component.options)
    }
    module.hot.accept("./CrearCliente.vue?vue&type=template&id=e45207b4&", function () {
      api.rerender('e45207b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/Editar/CrearCliente.vue"
export default component.exports